var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('RSpinnerOverlay',{attrs:{"loading":_vm.loading,"is-full-page":true}}),_c('router-view',{attrs:{"company":_vm.company,"property":_vm.property}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }